import { TEXTOS } from '../../../lib/glossario'
import type { CoberturaDaAnalise as Cobertura } from '../../../types/chamado'

/**
 * Quanto do mês a leitura automática leu — o denominador dos pontos listados logo abaixo.
 *
 * É a única coisa que a tela do fechamento afirmava sem base: a consolidação de alertas sai APENAS
 * dos chamados que têm parecer, e aparecia sozinha. "2 chamados com Pendente usado para parar o
 * relógio" sobre 3 lidos de 105 é uma amostra de três; sem esta linha, lê-se como retrato do mês, e
 * quem assina confere achando que conferiu.
 *
 * **Não leva selo de máquina, e é de propósito.** Isto não é texto de IA nem parecer: é uma
 * contagem. O selo aqui ensinaria a desconfiar de um número exato.
 *
 * Vem ANTES da lista, e não num rodapé: quem lê rápido lê o começo.
 *
 * @param props a cobertura apurada no fechamento
 * @returns o denominador da leitura automática
 */
export function CoberturaDaAnalise({ cobertura }: { cobertura: Cobertura }) {
  const t = TEXTOS.coberturaDaAnalise
  const nenhum = cobertura.analisados === 0
  const completa = cobertura.total > 0 && cobertura.analisados >= cobertura.total

  return (
    <section className="cartao p-5" aria-label={t.rotulo}>
      <h2 className="text-base font-semibold text-slate-900">{t.rotulo}</h2>
      <p className="mt-1 text-sm font-medium tabular-nums text-slate-900">
        {t.contagem(cobertura.analisados, cobertura.total)}
      </p>
      {/* Os três estados dizem coisas diferentes e não podem sair iguais: "não rodou" não é
          "rodou e não achou nada", e nenhum dos dois é "leu o mês inteiro". */}
      <p className="mt-2 max-w-prose text-sm text-slate-600">
        {nenhum ? t.nenhum : completa ? t.completa : t.amostra}
      </p>
    </section>
  )
}
